<template>
    <svg
        class="svg-indicate-line"
        xmlns="http://www.w3.org/2000/svg"
        width="52"
        height="22"
        viewBox="0 0 52 22"
        fill="none"
    >
        <path
            d="M0.999999 21L1.71766 18.4643C4.64179 8.13235 14.0729 1 24.8106 1H51"
            stroke="url(#paint0_linear_2530_36727)"
            stroke-width="2"
            stroke-linecap="round"
        />
        <defs>
            <linearGradient
                id="paint0_linear_2530_36727"
                x1="1"
                y1="-8.99934"
                x2="60.4262"
                y2="-8.99934"
                gradientUnits="userSpaceOnUse"
            >
                <stop stop-color="#37E6FE" />
                <stop offset="1" />
            </linearGradient>
        </defs>
    </svg>
</template>
